export default "__VITE_ASSET__2102524e__"